export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTimeISO: { input: unknown; output: unknown; }
};

export type ActivateExperimentInput = {
  experimentId: Scalars['Int']['input'];
};

export type AddAssignmentInput = {
  assignment_type_id: Scalars['Int']['input'];
  created_at?: InputMaybe<Scalars['String']['input']>;
  module_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  project_id: Scalars['Int']['input'];
  status_id?: InputMaybe<Scalars['Int']['input']>;
  target_completion_date?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AddMtDocumentInput = {
  assignmentId: Scalars['Int']['input'];
  documentUrl: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type AddUpdateAssignmentType = {
  name: Scalars['String']['input'];
};

export type AddUpdateLevelInput = {
  name: Scalars['String']['input'];
};

export type AddUpdateModuleInput = {
  level_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type AddUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role_id: Scalars['Int']['input'];
};

export type ApiIntegratorTokenResponse = {
  __typename?: 'ApiIntegratorTokenResponse';
  expiresIn: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type AssignedProjectUser = {
  __typename?: 'AssignedProjectUser';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  project_user_id: Scalars['Int']['output'];
  role: Role;
  role_id: Scalars['Int']['output'];
};

export type Assignment = {
  __typename?: 'Assignment';
  assignment_type_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  module_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status_id: Scalars['Int']['output'];
  target_completion_date?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type AssignmentGroup = {
  __typename?: 'AssignmentGroup';
  id: Scalars['Int']['output'];
  level_name: Scalars['String']['output'];
  modules: Array<ModuleGroup>;
  status_id: Scalars['Int']['output'];
};

export type AssignmentGroupData = {
  __typename?: 'AssignmentGroupData';
  assignment_type_id?: Maybe<Scalars['Int']['output']>;
  completed_tasks?: Maybe<Scalars['Int']['output']>;
  has_machine_translation: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  module_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status_id?: Maybe<Scalars['Int']['output']>;
  target_completion_date?: Maybe<Scalars['String']['output']>;
  total_tasks?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type AssignmentGroupResult = {
  __typename?: 'AssignmentGroupResult';
  assignment_group: Array<AssignmentGroup>;
  status_group: Array<StatusGroup>;
};

export type AssignmentIdWithTaskIds = {
  __typename?: 'AssignmentIdWithTaskIds';
  assignment_id: Scalars['Int']['output'];
  taskIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type AssignmentResponse = {
  __typename?: 'AssignmentResponse';
  assignmentTypeId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  moduleId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  statusId: Scalars['Int']['output'];
  targetCompletionDate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AssignmentType = {
  __typename?: 'AssignmentType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Book = {
  __typename?: 'Book';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ChapterWithSentences = {
  __typename?: 'ChapterWithSentences';
  book_id: Scalars['Int']['output'];
  chapter_title: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  sentences: Array<Sentence>;
};

export type CompleteRefdocTask = {
  __typename?: 'CompleteRefdocTask';
  assignmentId: Scalars['Int']['output'];
  assignmentIsCompleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
  translatedSentence: Scalars['String']['output'];
};

export type Country = {
  __typename?: 'Country';
  countryCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CreateExperimentInput = {
  assignmentId: Scalars['Int']['input'];
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  modelIds: Array<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
};

export type CreateOrUpdatePronounTranslationInput = {
  project_id: Scalars['Int']['input'];
  task_id: Scalars['Int']['input'];
  tasks_pronouns_id: Scalars['Int']['input'];
  translationTexts: Array<Scalars['String']['input']>;
};

export type CreateProjectInput = {
  countryId: Scalars['Int']['input'];
  document_source_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  org_id: Scalars['Int']['input'];
  target_completion_date: Scalars['String']['input'];
  target_language_id: Scalars['Int']['input'];
  training_frequency: Scalars['Int']['input'];
};

export type CreateTaskInput = {
  assignment_id: Scalars['Int']['input'];
  project_id: Scalars['Int']['input'];
  status_id: Scalars['Int']['input'];
  task_data_id: Scalars['Int']['input'];
  task_type_id: Scalars['Int']['input'];
};

export type CreateUpdateCountryInput = {
  countryCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DocumentInput = {
  language_id: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  type?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentSource = {
  __typename?: 'DocumentSource';
  copyrightNotice?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  languageId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DocumentTranslated = {
  __typename?: 'DocumentTranslated';
  id: Scalars['Int']['output'];
  language_id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['Int']['output']>;
  version_id?: Maybe<Scalars['Int']['output']>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Experiment = {
  __typename?: 'Experiment';
  assignmentId?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdByUser?: Maybe<User>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  models: Array<ExperimentModel>;
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  status: ExperimentStatus;
};

export type ExperimentModel = {
  __typename?: 'ExperimentModel';
  createdAt: Scalars['String']['output'];
  experimentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
};

export enum ExperimentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Started = 'STARTED'
}

export type ExportSourceDocInput = {
  assignmentId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExportSourceDocumentResponse = {
  __typename?: 'ExportSourceDocumentResponse';
  Bucket: Scalars['String']['output'];
  Key: Scalars['String']['output'];
};

export enum ExportType {
  All = 'ALL',
  Human = 'HUMAN',
  Machine = 'MACHINE'
}

export type HtTranslation = {
  __typename?: 'HTTranslation';
  text_tgt: Scalars['String']['output'];
  uid?: Maybe<Scalars['String']['output']>;
};

export type ImportHumanTranslationDocumentInput = {
  contentUrl: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImportHumanTranslationDocumentResponse = {
  __typename?: 'ImportHumanTranslationDocumentResponse';
  assignmentsCompleted: Scalars['Int']['output'];
  documentId: Scalars['Int']['output'];
  sentencesInserted: Scalars['Int']['output'];
  sentencesUpdated: Scalars['Int']['output'];
  tasksCompleted: Scalars['Int']['output'];
};

export type Language = {
  __typename?: 'Language';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Level = {
  __typename?: 'Level';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  authToken: Scalars['String']['output'];
  resetToken: Scalars['String']['output'];
};

export type MtDocument = {
  __typename?: 'MTDocument';
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type Module = {
  __typename?: 'Module';
  id: Scalars['Int']['output'];
  level_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ModuleGroup = {
  __typename?: 'ModuleGroup';
  actual_days: Scalars['Int']['output'];
  assignments: Array<AssignmentGroupData>;
  end_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  module_name: Scalars['String']['output'];
  start_date?: Maybe<Scalars['String']['output']>;
  status_id: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateExperiment: Experiment;
  addMTDocument: MtDocument;
  addModelToExperiment: ExperimentModel;
  addProjectUsers: Scalars['String']['output'];
  bookmarkTask: Task;
  completeRefdocTask: CompleteRefdocTask;
  createAssignment: AssignmentResponse;
  createAssignmentTypes: AssignmentType;
  createCountry: Country;
  createDocumentSource: DocumentSource;
  createDocumentSourceFromUri: DocumentSource;
  createDocumentTranslated: DocumentTranslated;
  createDocumentVersion: DocumentVersion;
  createExperiment: Experiment;
  createLanguage: Language;
  createLevel: Level;
  createModule: Module;
  createOrUpdatePronounTranslation: Array<TranslationResponse>;
  createProject: Project;
  createPronounListSource: PronounListSource;
  createPronounListTranslated: PronounListTranslated;
  createPronounSource: PronounSourceData;
  createPronounTranslated: PronounTranslated;
  createRefdocSentenceTranslated: RefdocSentenceTranslated;
  createRefdocTranslated: RefdocTranslated;
  createSentenceSource: SentenceSourceData;
  createSentenceTranslated: SentenceTranslatedData;
  createUser: User;
  deleteAssignment: Scalars['Boolean']['output'];
  deleteAssignmentTypes: Scalars['Boolean']['output'];
  deleteCountry: Scalars['Boolean']['output'];
  deleteExperiment: Scalars['Boolean']['output'];
  deleteLanguage: Language;
  deleteLevel: Scalars['Boolean']['output'];
  deleteModule: Scalars['Boolean']['output'];
  deleteProject: Scalars['Boolean']['output'];
  deleteProjectUser: Scalars['String']['output'];
  deletePronounTranslated: Scalars['Boolean']['output'];
  deleteSourceDoc: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  distributeAssignment: Array<DistributeAssignmentResponse>;
  exportSourceDocument: ExportSourceDocumentResponse;
  forgotPassword: Scalars['String']['output'];
  generateApiIntegratorToken: ApiIntegratorTokenResponse;
  importHumanTranslationDocument: ImportHumanTranslationDocumentResponse;
  login: LoginResponse;
  removeModelFromExperiment: Scalars['Boolean']['output'];
  resetPassword: Scalars['String']['output'];
  triggerMachineTranslationGeneration: TriggerMachineTranslationGenerationResponse;
  unlockAssignment: Scalars['Boolean']['output'];
  updateAssignment: AssignmentResponse;
  updateAssignmentTypes: AssignmentType;
  updateCountry: Country;
  updateExperiment: Experiment;
  updateLevel: Level;
  updateMyProfile: User;
  updateProject: Project;
  updateProjectIntegration?: Maybe<Project>;
  updateRefdocSentenceTranslated: RefdocSentenceTranslated;
  updateRunningExperimentByAssignmentId: Experiment;
  updateSelectedModelForProject: UpdateSelectedModelForProjectResponse;
  updateSentenceTranslated: SentenceTranslatedData;
  updateTask: Task;
  updateTaskModelSelection: TaskModelSelection;
  updateTaskPeerReview: TaskPeerReview;
  updateTaskRating: TaskRating;
  updateTaskTranslation: TaskTranslation;
  updateTaskTuaaQuestion: TaskTuaaQuestion;
  updateUser: User;
  updateUserRole: User;
  upsertTaskNote: TaskNote;
};


export type MutationActivateExperimentArgs = {
  input: ActivateExperimentInput;
};


export type MutationAddMtDocumentArgs = {
  input: AddMtDocumentInput;
};


export type MutationAddModelToExperimentArgs = {
  experimentId: Scalars['Int']['input'];
  modelId: Scalars['String']['input'];
};


export type MutationAddProjectUsersArgs = {
  projectId: Scalars['Int']['input'];
  user_ids: Array<Scalars['Int']['input']>;
};


export type MutationBookmarkTaskArgs = {
  id: Scalars['Int']['input'];
  is_bookmarked: Scalars['Boolean']['input'];
};


export type MutationCompleteRefdocTaskArgs = {
  sentenceText: Scalars['String']['input'];
  taskId: Scalars['Int']['input'];
};


export type MutationCreateAssignmentArgs = {
  assignment: AddAssignmentInput;
};


export type MutationCreateAssignmentTypesArgs = {
  assignmentType: AddUpdateAssignmentType;
};


export type MutationCreateCountryArgs = {
  country: CreateUpdateCountryInput;
};


export type MutationCreateDocumentSourceArgs = {
  document: SourceDocumentInput;
};


export type MutationCreateDocumentSourceFromUriArgs = {
  document: SourceDocumentFromUriInput;
};


export type MutationCreateDocumentTranslatedArgs = {
  document: DocumentInput;
  version_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateDocumentVersionArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateExperimentArgs = {
  input: CreateExperimentInput;
};


export type MutationCreateLanguageArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateLevelArgs = {
  level: AddUpdateLevelInput;
};


export type MutationCreateModuleArgs = {
  module: AddUpdateModuleInput;
};


export type MutationCreateOrUpdatePronounTranslationArgs = {
  pronouns: CreateOrUpdatePronounTranslationInput;
};


export type MutationCreateProjectArgs = {
  project: CreateProjectInput;
};


export type MutationCreatePronounListSourceArgs = {
  pronounList: PronounListRefdocsInput;
};


export type MutationCreatePronounListTranslatedArgs = {
  pronounList: PronounListRefdocsInput;
};


export type MutationCreatePronounSourceArgs = {
  pronoun: PronounInput;
};


export type MutationCreatePronounTranslatedArgs = {
  pronoun: PronounInput;
};


export type MutationCreateRefdocSentenceTranslatedArgs = {
  refdocSentence: RefdocSentenceInput;
};


export type MutationCreateRefdocTranslatedArgs = {
  refdoc: PronounListRefdocsInput;
};


export type MutationCreateSentenceSourceArgs = {
  sentence: SentenceInput;
};


export type MutationCreateSentenceTranslatedArgs = {
  sentence: SentenceInput;
};


export type MutationCreateUserArgs = {
  user: AddUserInput;
};


export type MutationDeleteAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAssignmentTypesArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCountryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteExperimentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteLanguageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteLevelArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteModuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProjectArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationDeleteProjectUserArgs = {
  projectUserId: Scalars['Int']['input'];
};


export type MutationDeletePronounTranslatedArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSourceDocArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDistributeAssignmentArgs = {
  level_ids: Array<Scalars['Int']['input']>;
  project_id: Scalars['Int']['input'];
};


export type MutationExportSourceDocumentArgs = {
  input: ExportSourceDocInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};


export type MutationGenerateApiIntegratorTokenArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationImportHumanTranslationDocumentArgs = {
  input: ImportHumanTranslationDocumentInput;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationRemoveModelFromExperimentArgs = {
  experimentId: Scalars['Int']['input'];
  modelId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  confirmPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};


export type MutationTriggerMachineTranslationGenerationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
};


export type MutationUnlockAssignmentArgs = {
  payload: UnlockAssignmentInput;
};


export type MutationUpdateAssignmentArgs = {
  assignment: UpdateAssignmentInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateAssignmentTypesArgs = {
  assignmentType: AddUpdateAssignmentType;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCountryArgs = {
  country: CreateUpdateCountryInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateExperimentArgs = {
  input: UpdateExperimentInput;
};


export type MutationUpdateLevelArgs = {
  id: Scalars['Int']['input'];
  level: AddUpdateLevelInput;
};


export type MutationUpdateMyProfileArgs = {
  user: UpdateMyProfileInput;
};


export type MutationUpdateProjectArgs = {
  id: Scalars['Int']['input'];
  project: UpdateProjectInput;
};


export type MutationUpdateProjectIntegrationArgs = {
  input: UpdateProjectIntegrationInput;
};


export type MutationUpdateRefdocSentenceTranslatedArgs = {
  id: Scalars['Int']['input'];
  refdoc_sentence_text: Scalars['String']['input'];
};


export type MutationUpdateRunningExperimentByAssignmentIdArgs = {
  input: UpdateRunningExperimentByAssignmentIdInput;
};


export type MutationUpdateSelectedModelForProjectArgs = {
  modelId: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationUpdateSentenceTranslatedArgs = {
  id: Scalars['Int']['input'];
  sentence_text: Scalars['String']['input'];
};


export type MutationUpdateTaskArgs = {
  id: Scalars['Int']['input'];
  task: UpdateTaskInput;
};


export type MutationUpdateTaskModelSelectionArgs = {
  best_translated_sentence_id: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  model_id: Scalars['String']['input'];
};


export type MutationUpdateTaskPeerReviewArgs = {
  sentence_text: Scalars['String']['input'];
  task_id: Scalars['Int']['input'];
  translated_sentence_id: Scalars['Int']['input'];
};


export type MutationUpdateTaskRatingArgs = {
  id: Scalars['Int']['input'];
  rating: Scalars['Int']['input'];
};


export type MutationUpdateTaskTranslationArgs = {
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  sentence_text: Scalars['String']['input'];
};


export type MutationUpdateTaskTuaaQuestionArgs = {
  answer: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUpdateUserArgs = {
  id: Scalars['Int']['input'];
  user: UpdateUserInput;
};


export type MutationUpdateUserRoleArgs = {
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpsertTaskNoteArgs = {
  noteId?: InputMaybe<Scalars['Int']['input']>;
  noteText: Scalars['String']['input'];
  taskId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type Note = {
  __typename?: 'Note';
  id: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  task_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type NoteInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['Int']['input'];
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  id: Scalars['Int']['output'];
  is_org_admin: Scalars['Boolean']['output'];
  org_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type Project = {
  __typename?: 'Project';
  completed_at?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  created_at: Scalars['String']['output'];
  document_source: DocumentSource;
  document_source_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  org_id: Scalars['Int']['output'];
  source_language: Language;
  target_completion_date: Scalars['String']['output'];
  target_language: Language;
  training_frequency: Scalars['Int']['output'];
};

export type ProjectLevel = {
  __typename?: 'ProjectLevel';
  project_id: Scalars['Int']['output'];
  project_level: Scalars['Int']['output'];
};

export type ProjectsFilterInput = {
  documentSourceId?: InputMaybe<Scalars['Int']['input']>;
};

export type Pronoun = {
  __typename?: 'Pronoun';
  country_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PronounInput = {
  pronoun_list_id: Scalars['Int']['input'];
  pronoun_text: Scalars['String']['input'];
};

export type PronounListRefdocsInput = {
  language_id: Scalars['Int']['input'];
  org_id: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['Int']['input']>;
};

export type PronounListSource = {
  __typename?: 'PronounListSource';
  id: Scalars['Int']['output'];
  language_id: Scalars['Int']['output'];
  org_id: Scalars['Int']['output'];
  type?: Maybe<Scalars['Int']['output']>;
};

export type PronounListTranslated = {
  __typename?: 'PronounListTranslated';
  id: Scalars['Int']['output'];
  language_id: Scalars['Int']['output'];
  org_id: Scalars['Int']['output'];
  type?: Maybe<Scalars['Int']['output']>;
};

export type PronounResponse = {
  __typename?: 'PronounResponse';
  is_bookmarked?: Maybe<Scalars['Boolean']['output']>;
  notes: Array<TaskNote>;
  source_text: Scalars['String']['output'];
  status_id?: Maybe<Scalars['Int']['output']>;
  task_id: Scalars['Int']['output'];
  task_pronouns_id: Scalars['Int']['output'];
  translations: Array<TranslationResponse>;
};

export type PronounSourceData = {
  __typename?: 'PronounSourceData';
  id: Scalars['Int']['output'];
  pronoun_list_source_id: Scalars['Int']['output'];
  pronoun_text: Scalars['String']['output'];
};

export type PronounTranslated = {
  __typename?: 'PronounTranslated';
  id: Scalars['Int']['output'];
  pronoun_list_translated_id: Scalars['Int']['output'];
  pronoun_text: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeExperiment?: Maybe<Experiment>;
  assignmentDetails: AssignmentDetail;
  assignmentGroup: AssignmentGroupResult;
  assignmentTypes: Array<AssignmentType>;
  assignments?: Maybe<Array<Maybe<Assignment>>>;
  books: Array<Book>;
  calculatedModelForProject?: Maybe<CalculatedModelForProjectResponse>;
  chaptersWithSentences: Array<ChapterWithSentences>;
  countries: Array<Country>;
  documentVersions: Array<DocumentVersion>;
  documentsSource: Array<DocumentSource>;
  experiment: Experiment;
  experimentModelIds: Array<Scalars['String']['output']>;
  experimentsByProject: Array<Experiment>;
  getProjectLevels: Array<ProjectLevel>;
  hasActiveExperiment: Scalars['Boolean']['output'];
  hasRunningExperiment: Scalars['Boolean']['output'];
  languages: Array<Language>;
  levels: Array<Level>;
  modules: Array<Module>;
  myProfile: User;
  organizationUser?: Maybe<OrganizationUser>;
  projectByIntegrationId?: Maybe<Project>;
  projectDetail: Project;
  projectUnAssignedUsers: Array<UnAssignedProjectUser>;
  projectUsers: Array<AssignedProjectUser>;
  projects: Array<Project>;
  pronouns: Array<PronounResponse>;
  refdocTasks: Array<RefdocTasks>;
  roles: Array<Role>;
  runningExperiment?: Maybe<Experiment>;
  sourceDocumentContent: SourceDocumentContent;
  task?: Maybe<Task>;
  tasksPerAssignment: Array<TaskWithData>;
  translatedDocument: TranslatedDocumentConnection;
  users: Array<User>;
};


export type QueryActiveExperimentArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryAssignmentDetailsArgs = {
  assignment_id: Scalars['Int']['input'];
};


export type QueryAssignmentGroupArgs = {
  is_admin_view?: InputMaybe<Scalars['Boolean']['input']>;
  project_id: Scalars['Int']['input'];
};


export type QueryCalculatedModelForProjectArgs = {
  levelId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type QueryChaptersWithSentencesArgs = {
  book_id: Scalars['Int']['input'];
  document_id: Scalars['Int']['input'];
};


export type QueryExperimentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExperimentModelIdsArgs = {
  experimentId: Scalars['Int']['input'];
};


export type QueryExperimentsByProjectArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryHasActiveExperimentArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryHasRunningExperimentArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryProjectByIntegrationIdArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryProjectDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectUnAssignedUsersArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryProjectUsersArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryProjectsArgs = {
  filter?: InputMaybe<ProjectsFilterInput>;
};


export type QueryPronounsArgs = {
  assignment_id: Scalars['Int']['input'];
};


export type QueryRefdocTasksArgs = {
  assignmentId: Scalars['Int']['input'];
};


export type QueryRunningExperimentArgs = {
  assignmentId?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
};


export type QuerySourceDocumentContentArgs = {
  bookId: Scalars['Int']['input'];
  documentId: Scalars['Int']['input'];
};


export type QueryTaskArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTasksPerAssignmentArgs = {
  assignment_id: Scalars['Int']['input'];
};


export type QueryTranslatedDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: TranslatedDocumentInput;
};

export type RefdocSentenceInput = {
  refdoc_id: Scalars['Int']['input'];
  refdoc_sentence_text: Scalars['String']['input'];
};

export type RefdocSentenceSource = {
  __typename?: 'RefdocSentenceSource';
  id: Scalars['Int']['output'];
  refdoc_sentence_text: Scalars['String']['output'];
  refdoc_source_id: Scalars['Int']['output'];
};

export type RefdocSentenceTranslated = {
  __typename?: 'RefdocSentenceTranslated';
  id: Scalars['Int']['output'];
  refdoc_sentence_text: Scalars['String']['output'];
  refdoc_translated_id: Scalars['Int']['output'];
};

export type RefdocSource = {
  __typename?: 'RefdocSource';
  id: Scalars['Int']['output'];
  language_id: Scalars['Int']['output'];
  org_id: Scalars['Int']['output'];
  type?: Maybe<Scalars['Int']['output']>;
};

export type RefdocTasks = {
  __typename?: 'RefdocTasks';
  id: Scalars['Int']['output'];
  isBookmarked: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  notes: Array<TaskNote>;
  sourceSentence: Scalars['String']['output'];
  title: Scalars['String']['output'];
  translatedSentence?: Maybe<Scalars['String']['output']>;
};

export type RefdocTranslated = {
  __typename?: 'RefdocTranslated';
  id: Scalars['Int']['output'];
  language_id: Scalars['Int']['output'];
  org_id: Scalars['Int']['output'];
  type?: Maybe<Scalars['Int']['output']>;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['Int']['output'];
  role_type: Scalars['String']['output'];
};

export type Sentence = {
  __typename?: 'Sentence';
  book_id: Scalars['Int']['output'];
  chapter_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isTitle?: Maybe<Scalars['Boolean']['output']>;
  sentence_number: Scalars['Int']['output'];
  sentence_text: Scalars['String']['output'];
  subSentenceNumber: Scalars['Int']['output'];
};

export type SentenceInput = {
  book_id: Scalars['Int']['input'];
  chapter_id?: InputMaybe<Scalars['Int']['input']>;
  document_id: Scalars['Int']['input'];
  isTitle?: InputMaybe<Scalars['Boolean']['input']>;
  sentence_number: Scalars['Int']['input'];
  sentence_text: Scalars['String']['input'];
  subSentenceNumber: Scalars['Int']['input'];
};

export type SentencePair = {
  source_sentence_id: Scalars['Int']['input'];
  translated_sentence_id?: InputMaybe<Scalars['Int']['input']>;
};

export type SentencePairRequired = {
  source_sentence_id: Scalars['Int']['input'];
  translated_sentence_id: Scalars['Int']['input'];
};

export type SentenceSource = {
  __typename?: 'SentenceSource';
  book_id: Scalars['Int']['output'];
  book_title: Scalars['String']['output'];
  chapter_id: Scalars['Int']['output'];
  chapter_title: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isTitle?: Maybe<Scalars['Boolean']['output']>;
  sentence_number: Scalars['Int']['output'];
  sentence_text: Scalars['String']['output'];
  subSentenceNumber: Scalars['Int']['output'];
};

export type SentenceSourceData = {
  __typename?: 'SentenceSourceData';
  chapter_id: Scalars['Int']['output'];
  document_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isTitle?: Maybe<Scalars['Boolean']['output']>;
  sentence_number: Scalars['Int']['output'];
  sentence_text: Scalars['String']['output'];
  subSentenceNumber: Scalars['Int']['output'];
};

export type SentenceTranslated = {
  __typename?: 'SentenceTranslated';
  book_id?: Maybe<Scalars['Int']['output']>;
  book_title?: Maybe<Scalars['String']['output']>;
  chapter_id?: Maybe<Scalars['Int']['output']>;
  chapter_title?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isTitle?: Maybe<Scalars['Boolean']['output']>;
  sentence_number?: Maybe<Scalars['Int']['output']>;
  sentence_text?: Maybe<Scalars['String']['output']>;
  subSentenceNumber?: Maybe<Scalars['Int']['output']>;
};

export type SentenceTranslatedData = {
  __typename?: 'SentenceTranslatedData';
  chapter_id: Scalars['Int']['output'];
  document_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isTitle?: Maybe<Scalars['Boolean']['output']>;
  sentence_number: Scalars['Int']['output'];
  sentence_text: Scalars['String']['output'];
  subSentenceNumber: Scalars['Int']['output'];
};

export type SourceDocumentContent = {
  __typename?: 'SourceDocumentContent';
  content: Array<ChapterWithSentences>;
  copyrightNotice?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  languageId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SourceDocumentFromUriInput = {
  contentUri: Scalars['String']['input'];
  copyrightNotice?: InputMaybe<Scalars['String']['input']>;
  languageId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type SourceDocumentInput = {
  content: Array<SourceSentenceInput>;
  copyrightNotice?: InputMaybe<Scalars['String']['input']>;
  languageId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type SourceSentenceInput = {
  UID: Scalars['String']['input'];
  bookId: Scalars['Int']['input'];
  chapterId: Scalars['Int']['input'];
  isTitle?: InputMaybe<Scalars['Boolean']['input']>;
  sentenceNumber: Scalars['Int']['input'];
  sentenceText: Scalars['String']['input'];
  subSentenceNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusGroup = {
  __typename?: 'StatusGroup';
  status: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type Task = {
  __typename?: 'Task';
  assignment_id: Scalars['Int']['output'];
  completed_at?: Maybe<Scalars['DateTimeISO']['output']>;
  created_at?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  is_bookmarked?: Maybe<Scalars['Boolean']['output']>;
  project_id: Scalars['Int']['output'];
  started_at?: Maybe<Scalars['DateTimeISO']['output']>;
  status_id: Scalars['Int']['output'];
  task_data_id: Scalars['Int']['output'];
  task_type_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TaskData = TaskModelSelectionData | TaskPeerReviewData | TaskRatingData | TaskTranslationData | TaskTuaaData;

export type TaskModelSelection = {
  __typename?: 'TaskModelSelection';
  bestTranslatedSentenceId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  sourceSentenceId: Scalars['Int']['output'];
};

export type TaskModelSelectionData = {
  __typename?: 'TaskModelSelectionData';
  best_translated_sentence_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  options: Array<TaskModelSelectionOptionData>;
  source_sentence?: Maybe<SentenceSource>;
  source_sentence_id: Scalars['Int']['output'];
};

export type TaskModelSelectionOption = {
  __typename?: 'TaskModelSelectionOption';
  id: Scalars['Int']['output'];
  model_id?: Maybe<Scalars['String']['output']>;
  task_model_selection_id: Scalars['Int']['output'];
  translated_sentence?: Maybe<SentenceTranslated>;
  translated_sentence_id: Scalars['Int']['output'];
};

export type TaskModelSelectionOptionData = {
  __typename?: 'TaskModelSelectionOptionData';
  id: Scalars['Int']['output'];
  model_id?: Maybe<Scalars['String']['output']>;
  task_model_selection_id: Scalars['Int']['output'];
  translated_sentence?: Maybe<SentenceTranslated>;
  translated_sentence_id: Scalars['Int']['output'];
};

export type TaskNote = {
  __typename?: 'TaskNote';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userDetails: TaskNoteUser;
};

export type TaskNoteUser = {
  __typename?: 'TaskNoteUser';
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type TaskPeerReview = {
  __typename?: 'TaskPeerReview';
  id: Scalars['Int']['output'];
  source_sentence_id: Scalars['Int']['output'];
  translated_sentence_id: Scalars['Int']['output'];
};

export type TaskPeerReviewData = {
  __typename?: 'TaskPeerReviewData';
  id: Scalars['Int']['output'];
  source_sentence?: Maybe<SentenceSource>;
  translated_sentence?: Maybe<SentenceTranslated>;
};

export type TaskPronouns = {
  __typename?: 'TaskPronouns';
  id: Scalars['Int']['output'];
  pronoun_source_id: Scalars['Int']['output'];
};

export type TaskRating = {
  __typename?: 'TaskRating';
  id: Scalars['Int']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  source_sentence_id: Scalars['Int']['output'];
  translated_sentence_id: Scalars['Int']['output'];
};

export type TaskRatingData = {
  __typename?: 'TaskRatingData';
  id: Scalars['Int']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  source_sentence?: Maybe<SentenceSource>;
  translated_sentence?: Maybe<SentenceTranslated>;
};

export type TaskRefdocs = {
  __typename?: 'TaskRefdocs';
  id: Scalars['Int']['output'];
  refdoc_source_sentence_id: Scalars['Int']['output'];
  refdoc_translated_sentence_id: Scalars['Int']['output'];
};

export type TaskTranslation = {
  __typename?: 'TaskTranslation';
  id: Scalars['Int']['output'];
  source_sentence_id: Scalars['Int']['output'];
  translated_sentence_id?: Maybe<Scalars['Int']['output']>;
};

export type TaskTranslationData = {
  __typename?: 'TaskTranslationData';
  book_id: Scalars['Int']['output'];
  book_title: Scalars['String']['output'];
  chapter_id?: Maybe<Scalars['Int']['output']>;
  chapter_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  source_sentence_id: Scalars['Int']['output'];
  source_sentence_number: Scalars['Int']['output'];
  source_sentence_text: Scalars['String']['output'];
  translated_sentence_id?: Maybe<Scalars['Int']['output']>;
  translated_sentence_text?: Maybe<Scalars['String']['output']>;
};

export type TaskTuaa = {
  __typename?: 'TaskTuaa';
  id: Scalars['Int']['output'];
};

export type TaskTuaaData = {
  __typename?: 'TaskTuaaData';
  book_title: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  questions: Array<TaskTuaaQuestionAndAnswer>;
  source_sentences: Array<SentenceSource>;
  translated_sentences: Array<SentenceTranslated>;
};

export type TaskTuaaQuestion = {
  __typename?: 'TaskTuaaQuestion';
  answer?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  task_tuaa_id: Scalars['Int']['output'];
  tuaa_question_id: Scalars['Int']['output'];
};

export type TaskTuaaQuestionAndAnswer = {
  __typename?: 'TaskTuaaQuestionAndAnswer';
  answer?: Maybe<Scalars['Int']['output']>;
  question: Scalars['String']['output'];
  question_id: Scalars['Int']['output'];
  question_type: Scalars['Int']['output'];
};

export type TaskWithData = {
  __typename?: 'TaskWithData';
  assignment_id: Scalars['Int']['output'];
  completed_at?: Maybe<Scalars['DateTimeISO']['output']>;
  created_at?: Maybe<Scalars['DateTimeISO']['output']>;
  data?: Maybe<TaskData>;
  id: Scalars['Int']['output'];
  is_bookmarked?: Maybe<Scalars['Boolean']['output']>;
  notes: Array<TaskNote>;
  project_id: Scalars['Int']['output'];
  started_at?: Maybe<Scalars['DateTimeISO']['output']>;
  status_id: Scalars['Int']['output'];
  task_data_id: Scalars['Int']['output'];
  task_type_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type Task_Pronouns_Translation = {
  __typename?: 'Task_Pronouns_Translation';
  id: Scalars['Int']['output'];
  pronoun_translated_id: Scalars['Int']['output'];
  task_pronouns_id: Scalars['Int']['output'];
};

export type TranslatedDocumentConnection = {
  __typename?: 'TranslatedDocumentConnection';
  pageInfo: PageInfo;
  sentences: Array<TranslatedDocumentSentence>;
};

export type TranslatedDocumentInput = {
  bookIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  exportType?: InputMaybe<ExportType>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
};

export type TranslatedDocumentSentence = {
  __typename?: 'TranslatedDocumentSentence';
  UID?: Maybe<Scalars['String']['output']>;
  bookId: Scalars['Int']['output'];
  chapterId: Scalars['Int']['output'];
  isTitle?: Maybe<Scalars['Boolean']['output']>;
  sentenceNumber: Scalars['Int']['output'];
  sentenceText: Scalars['String']['output'];
  subSentenceNumber: Scalars['Int']['output'];
};

export type TranslationResponse = {
  __typename?: 'TranslationResponse';
  pronoun_text: Scalars['String']['output'];
};

export enum TriggerMachineTranslationGenerationStatus {
  MaxTrainingFrequencyExceeded = 'MAX_TRAINING_FREQUENCY_EXCEEDED',
  Started = 'STARTED',
  TrainingAlreadyInProgress = 'TRAINING_ALREADY_IN_PROGRESS'
}

export type TuaaQuestion = {
  __typename?: 'TuaaQuestion';
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type UnAssignedProjectUser = {
  __typename?: 'UnAssignedProjectUser';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  role: Role;
  role_id: Scalars['Int']['output'];
};

export type UnlockAssignmentInput = {
  assignmentId?: InputMaybe<Scalars['Int']['input']>;
  levelId?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
};

export type UnlockedAssignmentResponse = {
  __typename?: 'UnlockedAssignmentResponse';
  id: Scalars['Int']['output'];
  status_id: Scalars['Int']['output'];
};

export type UpdateAssignmentInput = {
  assignment_type_id?: InputMaybe<Scalars['Int']['input']>;
  module_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status_id?: InputMaybe<Scalars['Int']['input']>;
  target_completion_date?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateExperimentInput = {
  completedAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<ExperimentStatus>;
};

export type UpdateMyProfileInput = {
  confirm_new_password?: InputMaybe<Scalars['String']['input']>;
  current_password?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  new_password?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProjectInput = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  target_completion_date: Scalars['String']['input'];
  training_frequency: Scalars['Int']['input'];
};

export type UpdateProjectIntegrationInput = {
  integrationId: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type UpdateRunningExperimentByAssignmentIdInput = {
  assignmentId: Scalars['Int']['input'];
  completedAt?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<ExperimentStatus>;
};

export type UpdateTaskInput = {
  status_id: Scalars['Int']['input'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  role?: Maybe<Role>;
  role_id: Scalars['Int']['output'];
};

export type AssignmentDetail = {
  __typename?: 'assignmentDetail';
  assignment_id: Scalars['Int']['output'];
  assignment_name: Scalars['String']['output'];
  assignment_type_id?: Maybe<Scalars['Int']['output']>;
  isBlocked: Scalars['Boolean']['output'];
  level_id: Scalars['Int']['output'];
  level_name: Scalars['String']['output'];
  module_id: Scalars['Int']['output'];
  module_name: Scalars['String']['output'];
  project_id?: Maybe<Scalars['Int']['output']>;
  status_id?: Maybe<Scalars['Int']['output']>;
};

export type CalculatedModelForProjectResponse = {
  __typename?: 'calculatedModelForProjectResponse';
  calculatedModelId: Scalars['String']['output'];
  levelId: Scalars['Int']['output'];
  projectId: Scalars['Int']['output'];
};

export type DistributeAssignmentResponse = {
  __typename?: 'distributeAssignmentResponse';
  assignment_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type TriggerMachineTranslationGenerationResponse = {
  __typename?: 'triggerMachineTranslationGenerationResponse';
  assignmentId?: Maybe<Scalars['Int']['output']>;
  assignmentName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  experimentId?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['Int']['output'];
  status: TriggerMachineTranslationGenerationStatus;
};

export type UpdateSelectedModelForProjectResponse = {
  __typename?: 'updateSelectedModelForProjectResponse';
  projectId: Scalars['Int']['output'];
  selectedModelId: Scalars['String']['output'];
};
